import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Public Components
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import About from './pages/About';

// Admin Components
import AdminLogin from './admin/AdminLogin';
import Dashboard from './admin/Dashboard';
import CustomerManagement from './admin/CustomerManagement';
import MeasurementManagement from './admin/MeasurementManagement';
import OrderManagement from './admin/OrderManagement';
import ServiceManagement from './admin/ServiceManagement';
import GalleryManagement from './admin/GalleryManagement';
import Reports from './admin/Reports';
import AnalyticsDashboard from './admin/AnalyticsDashboard'; // NEW

// Analytics Component
import Analytics from './components/Analytics'; // NEW

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

// Public Layout Component
const PublicLayout = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <Header />
      <main style={{ flex: 1 }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

// Admin Layout Component (without Header/Footer)
const AdminLayout = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa'
    }}>
      <main style={{ flex: 1 }}>
        {children}
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        {/* Analytics component tracks ALL public routes but excludes admin routes */}
        <Analytics />
        
        <Routes>
          {/* Public Routes with Layout */}
          <Route path="/" element={
            <PublicLayout>
              <Home />
            </PublicLayout>
          } />
          <Route path="/services" element={
            <PublicLayout>
              <Services />
            </PublicLayout>
          } />
          <Route path="/gallery" element={
            <PublicLayout>
              <Gallery />
            </PublicLayout>
          } />
          <Route path="/about" element={
            <PublicLayout>
              <About />
            </PublicLayout>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={
            <AdminLayout>
              <AdminLogin />
            </AdminLayout>
          } />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/customers" element={
            <ProtectedRoute>
              <AdminLayout>
                <CustomerManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/measurements" element={
            <ProtectedRoute>
              <AdminLayout>
                <MeasurementManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/orders" element={
            <ProtectedRoute>
              <AdminLayout>
                <OrderManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/services" element={
            <ProtectedRoute>
              <AdminLayout>
                <ServiceManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/gallery" element={
            <ProtectedRoute>
              <AdminLayout>
                <GalleryManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/reports" element={
            <ProtectedRoute>
              <AdminLayout>
                <Reports />
              </AdminLayout>
            </ProtectedRoute>
          } />
          {/* NEW: Analytics Dashboard Route */}
          <Route path="/admin/analytics" element={
            <ProtectedRoute>
              <AdminLayout>
                <AnalyticsDashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;